import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
export function SimpleDialog(props) {
    const [isOpen, setIsOpen] = useState(false);
    return (_jsxs(Fragment, { children: [_jsx(Button, { color: props.color, onClick: () => setIsOpen(true), children: props.title }), _jsx(Dialog, { onClose: () => setIsOpen(false), open: isOpen, color: props.color, children: _jsx(Box, { sx: { margin: "1em" }, children: props.content }) })] }));
}
//# sourceMappingURL=SimpleDialog.js.map